import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/settings/meeting/recording')({
	beforeLoad: () => {
		throw redirect({ to: '/settings/meeting/defaults' });
	},
});
